import config from '../config';
import BaseWindow from "./BaseWindow";

class SettingsPanel extends BaseWindow {
  init () {
    super.init();
    let g = this;
    g.info.panel = 'ben-panel.png';
    g.info.windowName = 'SettingsPanel';
    // console.log('SettingsPanel.init');
  }
  create () {
    super.create();
    let g = this;
    const textStyle = { fontFamily: g.game.localis.mainFont, fontSize: 44 +"px", color: "#ffffff",
      stroke: "#000000", strokeThickness: Math.ceil(11) };
    g.title = g.add.text(config.CENTER_X, 570, g.game.localis.GetString("settings").toLocaleUpperCase(g.game.localis.language), textStyle);
    g.title.setOrigin(0.5);
    g.title.y -= 1000;
    g.tweenAssets.push(g.title);
    g.open();
  }
}

export default SettingsPanel;
